import { Injectable } from '@angular/core';
import { BlockchainxHelper } from 'ng-blockchainx';
import { CommonContractService } from 'src/app/shared/services/common-contract.service';

const STANDARD = 'standard';
const LIQUIDITY = 'liquidity';

@Injectable({
  providedIn: 'root',
})
export class CreateTokenContractService {
  public standardTokenContract: any;
  public liquidityTokenContract: any;
  private STANDARD_TOKEN_CONTRACT_ADDRESS: string = '';
  private LIQUIDITY_TOKEN_CONTRACT_ADDRESS: string = '';

  constructor(
    private bxHelper: BlockchainxHelper,
    private commonContractService: CommonContractService,
  ) {

  }

  public async init() {
    this.standardTokenContract = await this.commonContractService.getContract(
      'STANDARD_TOKEN_CONTRACT'
    );
    this.liquidityTokenContract = await this.commonContractService.getContract(
      'LIQUIDITY_TOKEN_CONTRACT'
    );
    this.STANDARD_TOKEN_CONTRACT_ADDRESS =
      await this.commonContractService.getContractAddress(
        'STANDARD_TOKEN_CONTRACT'
      );
    this.LIQUIDITY_TOKEN_CONTRACT_ADDRESS =
      await this.commonContractService.getContractAddress(
        'LIQUIDITY_TOKEN_CONTRACT'
      );
  }

  public async createAbi(
    tokenName: any,
    tokenSymbol: any,
    decimal: any,
    totalSupply: any,
    tokenType: string,
    routerAddress?: string
  ) {
    const params = [
      tokenName,
      tokenSymbol,
      Number(decimal),
      this.bxHelper.decimalMultipler(Number(decimal), totalSupply),
    ];
    if (tokenType == STANDARD) {
      return await this.standardTokenContract.methods
        .createToken(...params)
        .encodeABI();
    } else {
      params.push(routerAddress);
      return await this.liquidityTokenContract.methods.createToken(...params).encodeABI();
    }

  }

  public createToken(
    walletAddress: string,
    createTokenAbi: any,
    fee: any,
    tokenType: string
  ) {
    return new Promise((resolve, reject) => {
      const message = {
        method: 'eth_sendTransaction',
        from: walletAddress,
        to:
          tokenType == STANDARD
            ? this.STANDARD_TOKEN_CONTRACT_ADDRESS
            : this.LIQUIDITY_TOKEN_CONTRACT_ADDRESS,
        data: createTokenAbi,
        value: fee
      }
      this.commonContractService.ethWeb3.eth.sendTransaction(message).then((receipt: any) => {
        resolve({ status: true, data: receipt });
      }).catch((error: any) => {
        reject({ status: false, data: error });
      });
    });
  }

  public async initiateTokenFeeAbi(
    tokenAddress: string,
    reflectionFee: any,
    liquidityFee: any,
    liquidityFeeToSell: any,
    marketingFee: any,
    marketingFeeToSell: any,
    marketingAddress: any,
    charityFee: any,
    charityFeeToSell: any,
    charityAddress: any,
    transactionLimit: any
  ) {
    const params: any[] = [
      tokenAddress,
      reflectionFee,
      liquidityFee,
      liquidityFeeToSell,
      marketingFee,
      marketingFeeToSell,
      marketingAddress,
      charityFee,
      charityFeeToSell,
      charityAddress,
      transactionLimit,
    ];
    return await this.liquidityTokenContract.methods
      .initializeTokenFees(...params)
      .encodeABI();
  }

  public initiateLiquidityTokenFees(walletAddress: string, abi: any) {
    return new Promise((resolve, reject) => {
      const message = {
        method: 'eth_sendTransaction',
        from: walletAddress,
        to: this.LIQUIDITY_TOKEN_CONTRACT_ADDRESS,
        data: abi,
      };
      this.commonContractService.ethWeb3.eth
        .sendTransaction(message)
        .then((receipt: any) => {
          resolve({ status: true, data: receipt });
        })
        .catch((error: any) => {
          reject({ status: false, data: error });
        });
    });
  }

  public async getStandardFee() {
    const fee = await this.standardTokenContract.methods.createFee().call();
    const feeToDisplay = await this.commonContractService.ethWeb3.utils.fromWei(
      fee
    );
    return { fee, feeToDisplay };
  }

  public async getLiquidityFee() {
    const fee = await this.liquidityTokenContract.methods.createFee().call();
    const feeToDisplay = await this.commonContractService.ethWeb3.utils.fromWei(
      fee
    );
    return { fee, feeToDisplay };
  }

  public async isValidAddress(address: string) {
    try {
      let response = await this.commonContractService.ethWeb3.eth.getCode(
        address
      );
      let status;
      if (response == '0x') status = true;
      else status = false;
      return status;
    } catch (err) {
      return false;
    }
  }

 
}
